const Loader = () => {
    return (<div className='w-full flex justify-center items-center'>
<div className="loadingio-spinner-ball-53xldhs8dc7"><div className="ldio-8x6akhntvrk">
<div></div>
</div></div>
    </div>    
    );
  }

  export default Loader;